/* eslint-disable import/prefer-default-export */
export const PROJECT_LIST = `
  query {
    projectList {
      code
      name
      templateCode
    }
  }
`;
